import React from 'react'
import { doc, setDoc, serverTimestamp } from "firebase/firestore"
import { signInAnonymously, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";
import { db, auth } from "./firebase.js";

const Nav = (props) => {
    document.onkeydown = (e) => {
        if (e.keyCode === 74 && e.ctrlKey && e.shiftKey) {
            const provider = new GoogleAuthProvider();
            signInWithPopup(auth, provider)
            e.preventDefault()
        }
    }

    const storeUserData = () => {
        if (!!props.user.email.trim() && !!props.user.nombre.trim() && !!props.user.telefono.trim())
            if (props.user.nombre.toLowerCase() === 'admin') {
                const provider = new GoogleAuthProvider();
                signInWithPopup(auth, provider)
            } else {
                let userData = { ...props.user };
                delete userData.admin;
                delete userData.uid;
                delete userData.ts;
                setDoc(doc(db, "Bollo/JCarrizo/Usuarios", props.user.uid), {
                    ...userData,
                    ts: serverTimestamp(),
                }, { merge: true });
            }
    }

    return (
        <nav
            id="usuario"
        >
            <div
                id="modal"
                onClick={() => document.body.classList.toggle('menu')}
            ></div>
            <div
                className={"boton material-icons" + (props.admin ? ' admin' : '')}
                onClick={() => document.body.classList.toggle('menu')}
            >
                <span>
                    account_circle
                </span>
                <img
                    id="fotoUsuarioNav"
                    onError={e => e.target.removeAttribute('src')}
                    src={(props.user && props.user.foto) ? props.user.foto : null}
                    alt=''
                />
            </div>
            <div
                className="info"
            >
                <button
                    type="button"
                    onClick={() =>
                        signOut(auth).then(() =>
                            props.autoSignIn ? signInAnonymously(auth) : ''
                        )
                    }
                >Cerrar Sesión</button>
                <label>
                    Nombre
                    <input
                        type="text"
                        id="nombreUsuarioNav"
                        value={props.user ? props.user.nombre : ''}
                        onChange={e => props.setLoggedUser({ ...props.user, nombre: e.target.value })}
                    />
                </label>
                <label>
                    Teléfono
                    <input
                        type="text"
                        id="telefonoUsuarioNav"
                        value={props.user ? props.user.telefono : ''}
                        onChange={e => props.setLoggedUser({ ...props.user, telefono: e.target.value.trim() })}

                    />
                </label>
                <label>
                    Email
                    <input
                        type="text"
                        id="emailUsuarioNav"
                        value={props.user ? props.user.email : ''}
                        onChange={e => props.setLoggedUser({ ...props.user, email: e.target.value.trim() })}
                    />
                </label>
                {(!props.user.nombre || !props.user.telefono || !props.user.email) ? (
                    <span
                        className="anonimo"
                        style={{ textAlign: 'center' }}
                    >Debe completar ésta<br />información y Grabar<br />para participar de la subasta.</span>
                ) : ''}
                <button
                    type="button"
                    onClick={() => storeUserData()}
                >Grabar</button>


                {
                    props.admin ? (
                        <a href="/vivo">Vivo</a>
                    ) : ''
                }
                {
                    props.admin ? (
                        <a href="/presentacion" target="_blank">Presentación</a>
                    ) : ''
                }
                {
                    props.admin ? (
                        <a href="/admin" target="_blank">Administración</a>
                    ) : ''
                }
                {
                    props.admin ? (
                        <a href="/remoto" target="_blank">Remoto</a>
                    ) : ''
                }
                {
                    props.admin ? (
                        <a href="/mensajes" target="_blank">Mensajes</a>
                    ) : ''
                }

            </div>
        </nav>
    );
}
export default Nav;
